export const DiccionarioSeguridad_EN = [
    {
        'codigo': 'CodeRequeridoEmailOName',
        'mensaje': 'You must enter a search filter'
    },
    {
        'codigo': 'UserReqCompany',
        'mensaje': 'The user needs to be linked to at least one company'
    },
    {
        'codigo': 'CustomerExistUser',
        'mensaje': 'The selected Administrative is already linked to another user'
    },
    {
        'codigo': 'ErrorClaveNoCoincide',
        'mensaje': 'The current key does not match'
    },
    {
        'codigo': 'ErrorCodeItemNotEmty',
        'mensaje': 'The code is required'
    },
    {
        'codigo': 'ErrorCreatingPerfil',
        'mensaje': 'There were problems creating the security profile'
    },
    {
        'codigo': 'ErrorCurrentCompaniaNotEmpty',
        'mensaje': 'Company data not found'
    },
    {
        'codigo': 'ErrorSecProfileIdNotEmty',
        'mensaje': 'You must select the security profile'
    },
    {
        'codigo': 'ErrorDeletePerfil',
        'mensaje': 'There were problems removing the security profile'
    },
    {
        'codigo': 'ErrorDscNotEmpty',
        'mensaje': 'Description is required'
    },
    {
        'codigo': 'ErrorEliminarUsuario',
        'mensaje': 'There were problems deleting the user'
    },
    {
        'codigo': 'ErrorExisteCorreo',
        'mensaje': 'The email entered is already registered for another user'
    },
    {
        'codigo': 'ErrorExisteUsuario',
        'mensaje': 'The data of the user to update was not found'
    },
    {
        'codigo': 'ErrorExisteUsuarioEmail',
        'mensaje': 'There is already a registered user with this email'
    },
    {
        'codigo': 'ErrorGetPerfil',
        'mensaje': 'There were problems obtaining the security profile data'
    },
    {
        'codigo': 'ErrorGetUsuarioDetalle',
        'mensaje': 'There were problems getting user data'
    },
    {
        'codigo': 'ErrorModuleIdNotEmty',
        'mensaje': 'Module data not found'
    },
    {
        'codigo': 'ErrorUpdatePerfil',
        'mensaje': 'There were problems updating the security profile'
    },
    {
        'codigo': 'ErrorUpdateSedesUsuario',
        'mensaje': 'Problems occurred when updating user campus'
    },
    {
        'codigo': 'ErrorUpdateUsuarioPerfil',
        'mensaje': 'There were problems updating user security profiles'
    },
    {
        'codigo': 'ErrorValidatingPerfil',
        'mensaje': 'There were problems validating the security profile'
    },
    {
        'codigo': 'FormartFileError',
        'mensaje': 'File format (extension) not allowed.'
    },
    {
        'codigo': 'CodeRangeDate1Year',
        'mensaje': 'There should be no more than 1 year difference between the start date and the end date.'
    },
    {
        'codigo': 'CodeRequeridoListaOpciones',
        'mensaje': 'There are no selected records to update.'
    },
    {
        'codigo': 'CodeMinimoMaximoCharacters',
        'mensaje': 'The minimum number of characters must not exceed the maximum value.'
    },
    {
        'codigo': 'CodeRequeridoEmail',
        'mensaje': 'Email is required.'
    },
    {
        'codigo': 'CodeRequeridoPerfilId',
        'mensaje': 'No safety profile data found.'
    },
    {
        'codigo': 'CodeRequeridoMinimo',
        'mensaje': 'The minimum value is required.'
    },
    {
        'codigo': 'CodeRequeridoMaximo',
        'mensaje': 'The maximum value is required.'
    },
    {
        'codigo': 'CodeRequeridoHistory',
        'mensaje': 'La cantidad de histórico de contraseñas es requerido.'
    },
    {
        'codigo': 'CodeRequeridoValidity',
        'mensaje': 'You must enter the number of days of validity.'
    },
    {
        'codigo': 'CodeRequeridoOldPassword',
        'mensaje': 'You must enter your current password.'
    },
    {
        'codigo': 'CodeRequeridoPassword',
        'mensaje': 'You must enter the new password.'
    },
    {
        'codigo': 'CodeRequeridoConfirmacionPassword',
        'mensaje': 'You must enter the confirmation password.'
    },
    {
        'codigo': 'CodeRequeridoDepartment',
        'mensaje': 'You must enter the apartment.'
    },
    {
        'codigo': 'ErrorContrasenaVacio',
        'mensaje': 'You must enter a password.'
    },
    {
        'codigo': 'ErrorEmailNotEmty',
        'mensaje': 'You must enter an email.'
    },
];
